<template>
    <form class="selector">
        <div v-for="option in options" class="form-group form-group-scale-selector" :data-selected="option.id === value">
            <button
                type="button"
                :name="parameter"
                class="button"
                :style="{ backgroundColor: retrieveColour(option) }"
                @click.stop="updateValues($event, option.id, retrieveColour(option))"
            >
                {{ option.value }}
            </button>
        </div>
    </form>
</template>

<script>
    import VisibleSelectorWidget from './VisibleSelectorWidget';

    export default {
        extends: VisibleSelectorWidget,
        data() {
            return {
                parameter: null
            }
        },
        created() {
            this.registerParameterListeners(this.parameters, [
                'title'
            ]);
        },
        methods: {
            async update(data) {
                if (data.display === 'none') {
                    return this.$el.closest('.page-widget').hidden = true;
                }

                this.options = data.items;
                this.parameter = data.parameter;
                this.setValue();
                this.updateTabColour(this.retrieveColour(this.options[0]));
            },
            updateValues(event, id = null, colour = null) {
                if (! id) {
                    id = this.value;
                    colour = this.retrieveColour(this.options.filter(option => option.id === id)[0]);
                }

                this.updateTabColour(colour);
                this.updateValue(event, id);
            },
            updateTabColour(colour) {
                document.documentElement.style.setProperty('--tabs-selected-colour', colour);
            },
            broadcast(value) {
                this.value = value;
                const eventName = 'update' + this.parameter.replace(/^\w/, c => c.toUpperCase());
                window.events.emit(eventName, value);
            }
        }
    }
</script>
